/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import { LinkAccountsButton } from 'components';
import { LinkAccountsSelect } from 'components/LinkAccountsButton';
import { useSelector } from 'react-redux';
import { selectLinkedStatuses } from 'selectors';

import SkipButton from './components/SkipButton';
import { styles } from './styles/linkAccounts.styles';

const LinkAccounts = ({ handleNext }) => {
	const linkedAccountsStatuses = useSelector(selectLinkedStatuses);

	const shouldDisplaySkip = linkedAccountsStatuses.data?.hubspot_linked;

	return (
		<Box sx={styles.root}>
			<Container maxWidth="sm">
				<Typography component="p" variant="h2" color="primary" sx={{ textAlign: 'center' }}>
					WELCOME
				</Typography>
				<Typography component="p" variant="subtitle1" color="textSecondary" sx={{ textAlign: 'center' }}>
					MemberCenter is here to support you with your membership needs.
				</Typography>
				<List>
					<ListItem>
						<LinkAccountsButton account="hubspot" handleNext={handleNext} />
						<Box sx={{ display: 'flex', flexDirection: 'column' }}>
							<Typography component={'span'} variant="h5" color="primary">
								HUBSPOT
							</Typography>
							<Typography component={'span'} variant="subtitle2" color="secondary">
								LINK HUBSPOT
							</Typography>
						</Box>
					</ListItem>
					<Box sx={{ display: 'flex', flexDirection: 'column' }}>
						<LinkAccountsSelect handleNext={handleNext} />
					</Box>
				</List>
				{shouldDisplaySkip && <SkipButton handleSkip={handleNext} />}
			</Container>
		</Box>
	);
};
export default LinkAccounts;
